/**
 * @author: dongjing
 * @file: description
 * @Date: 2020-01-06 14:29:02
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-26 10:57:03
 */
/**
 * @description default layout
 */

import React from 'react';
import { Layout, ConfigProvider, message } from 'antd';
import { IntlProvider, addLocaleData } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { IRootState } from '@src/types';

import { ErrorBoundary } from '@features/common/components';
import actions from './redux/actions';

import { SFCHeader, SFCFooter } from './components';

import './App.less';
import AdminHeader from './components/AdminHeader';

addLocaleData(LocalDataMessages.lang);

const mapStateToProps = (state: IRootState) => {
  return {
    home: state.home,
    articles: state.articles,
    message: state.message,
    ask: state.ask
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

interface AppProps extends RouteComponentProps<any> {}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & AppProps & DispatchProps & AppProps;

export class App extends React.Component<Props> {
  public render() {
    const { pathname } = this.props.location;
    return (
      <IntlProvider locale={LocalDataMessages.locale} messages={LocalDataMessages.messages}>
        <ConfigProvider locale={LocalDataMessages.antd}>
          <Layout className="home-app">
            <ErrorBoundary>
              {pathname.includes('admin') ? (
                <AdminHeader pathname={pathname} />
              ) : (
                <SFCHeader pathname={pathname} />
              )}
              <div className="content-box">
                <div className="k-layout-content">{this.props.children}</div>
                <SFCFooter hidden={false} />
              </div>
            </ErrorBoundary>
          </Layout>
        </ConfigProvider>
      </IntlProvider>
    );
  }
}

export default connect<StateProps, DispatchProps, AppProps>(
  mapStateToProps,
  mapDispatchToProps
)(App);
